<div class="dialog-panel">
  <div class="icon-close" [inlineSVG]="'/icons/icon-close.svg'" (click)="closeDialog()"></div>
  <div class="dialog-content">
    @if (loading) {
      <div class="spinner-container p-absolute">
        <mat-spinner class="primary" [diameter]="30"></mat-spinner>
      </div>
    }
    <form [ngClass]="{ 'v-hidden': loading }" [formGroup]="form" (submit)="onSubmit()">
      <div class="dialog-body pt-0">
        <p class="info-bold text-center">
          {{ 'global.enter_token' | transloco }}
        </p>
        <div class="form-field-container">
          <mat-form-field class="form-field" [floatLabel]="'auto'">
            <input matInput formControlName="token" required />
            @if (getFormControl('token').invalid) {
              <mat-error>
                @if (getFormControl('token').errors.required) {
                  {{ 'form.error.required' | transloco }}
                }
                @if (getFormControl('token').errors.invalid_token) {
                  {{ 'form.error.invalid_token' | transloco }}
                }
              </mat-error>
            }
          </mat-form-field>
        </div>
      </div>
      <div class="dialog-bottom">
        <button type="submit" class="btn btn-primary d-block w-100" [disabled]="form.invalid">
          {{ 'global.activate' | transloco }}
        </button>
      </div>
    </form>
  </div>
</div>
